module.exports = __webpack_public_path__ + "de0f896a770f3b9af7983cd6fd9c1655.png";


//////////////////
// WEBPACK FOOTER
// ./statics/imgs/home/shopping_dialog_bg.png
// module id = 184
// module chunks = 0